<template>
    <transition name="fade" leave-active-class="no-transition">
        <section v-show="isActive"
                :aria-hidden="!isActive"
                class="tabs-panel"
                :id="hash"
                role="tabpanel"
        >
            <slot />
        </section>
    </transition>
</template>

<script>
    export default {
        props: {
            id: { default: null },
            name: { required: true },
        },

        data: () => ({
            isActive: false,
        }),

        computed: {
            hash() {
                return this.id ?
                    '#' + this.id :
                    '#' + this.name.toLowerCase().replace(/ /g, '-');
            },
        },
    };
</script>